import * as Sentry from '@sentry/angular';

const WOO_ENV = window['WOO_ENV'] || ({} as any);

// Errors thrown by scripts a browser or extension injects into the page have no
// source file on any stack frame (e.g. Safari's "[native code]" for browser internals)
const INJECTED_FILENAMES = [undefined, '', 'undefined', '<anonymous>', '[native code]'];

const isFromInjectedScript = (event: Sentry.ErrorEvent): boolean => {
  const frames = event.exception?.values?.flatMap((value) => value.stacktrace?.frames ?? []) ?? [];
  return frames.length > 0 && frames.every((frame) => INJECTED_FILENAMES.includes(frame.filename));
};

Sentry.init({
  dsn: WOO_ENV.SENTRY_DSN,
  release: WOO_ENV.RELEASE_VERSION,
  ignoreErrors: ['EmptyRanges'],
  beforeSend: (event) => (isFromInjectedScript(event) ? null : event),
});
